package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.sddamico.components.motion.Durations
import com.sddamico.components.motion.Ease
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun TogglePill(checked: Boolean) {
    Div(
        Modifier
            .width(40.px)
            .height(22.px)
            .borderRadius(11.px)
            .backgroundColor(if (checked) SitePalette.primary else SitePalette.border)
            .position(Position.Relative)
            .transition(Transition.of("background-color", Durations.POPOVER.ms, Ease.Out.fn))
            .toAttrs()
    ) {
        Div(
            Modifier
                .width(16.px)
                .height(16.px)
                .borderRadius(8.px)
                .backgroundColor(Colors.White)
                .position(Position.Absolute)
                .top(3.px)
                .left(3.px)
                .translateX(if (checked) 18.px else 0.px)
                .transition(Transition.of("transform", Durations.POPOVER.ms, Ease.Out.fn))
                .toAttrs()
        )
    }
}
